module.exports = __webpack_public_path__ + "static/media/60008.b38e87cb.png";